import React, { useEffect, useState } from 'react'
import {
	Box,
	Button,
	Card,
	CardContent,
	TextField,
	Typography,
} from '@mui/material'
import { useNavigate } from 'react-router'
import { useParseVacancyMutation } from '../store/api/vacanciesApi'

const AddVacancyFromText = () => {
	const navigate = useNavigate()
	const [text, setText] = useState('')
	const [parse, { isSuccess, isLoading }] = useParseVacancyMutation()

	const handleCreate = () => {
		if (text) {
			parse({ raw_text: text })
		}
	}

	useEffect(() => {
		if (!isLoading && isSuccess) {
			navigate('/vacancies')
		}
	}, [isLoading])

	return (
		<Box maxWidth="700px" mx="auto" mt={4}>
			<Card>
				<CardContent>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Typography variant="h5" mr={4}>
							Текст вакансії
						</Typography>
						<Button
							variant="contained"
							color="primary"
							onClick={() => navigate('/add')}
						>
							Створити з форми
						</Button>
					</Box>
					<TextField
						fullWidth
						label="Опис вакансії"
						name="original_text"
						value={text}
						onChange={(e) => setText(e.target.value)}
						multiline
						rows={15}
						margin="normal"
					/>
					<Button
						loading={isLoading}
						color="primary"
						variant="contained"
						fullWidth
						sx={{ mt: 3 }}
						onClick={() => handleCreate()}
					>
						Створити
					</Button>
				</CardContent>
			</Card>
		</Box>
	)
}

export default AddVacancyFromText
